import { render, staticRenderFns } from "./Temperature.vue?vue&type=template&id=9916df60&scoped=true&"
import script from "./temperature.js?vue&type=script&lang=js&"
export * from "./temperature.js?vue&type=script&lang=js&"
import style0 from "./temperature.scss?vue&type=style&index=0&id=9916df60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9916df60",
  null
  
)

export default component.exports